export interface Workspace {
  name: string;
  id: string;
  quizzesCount: number;
  mode: WorkspaceMode;
}

export enum WorkspaceMode {
  VIEW_ONLY = 0,
  COLLABORATIVE = 1,
}
